import React from 'react';
import { CloseButton } from './CloseButton';

interface ModalHeaderProps {
  title?: string;
  onClose?: () => void;
  showCloseButton?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export function ModalHeader({ 
  title, 
  onClose, 
  showCloseButton = true, 
  children,
  className = ''
}: ModalHeaderProps) {
  return (
    <div className={`flex items-center justify-between p-6 border-b border-game-medium/30 ${className}`}>
      {/* Title or custom content */}
      <div className="flex-1">
        {title && <h2 className="text-2xl font-bold text-white">{title}</h2>}
        {children}
      </div>
      
      {/* Close Button */}
      {showCloseButton && onClose && (
        <CloseButton
          onClick={onClose}
          className="ml-4"
        />
      )}
    </div>
  );
}